/*
 * Copyright (c) Nexign, JSC, 2019-2024.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @author Maxim Fedorov
 * @author Aleksandr Perkhunov
 * @author Ilya Baranchikov
 * @version 1.30.0
 * @since 1.0.0
 */

import { createSelector, OutputSelector } from 'reselect';

import { IRootReducer } from '../../reducers/rootReducer';
import { IBannerReducer } from './bannerReducers';
import { IBannerItem } from './bannerTypes';

export const makeSelectorBanner = (state: IRootReducer): IBannerReducer => state.banner;

/*
 * -------------------------------------------
 *              BANNERS
 * -------------------------------------------
 */

export const makeSelectorBannersList = (): OutputSelector<
    IRootReducer,
    IBannerItem[],
    (state: IBannerReducer) => IBannerItem[]
> => createSelector(makeSelectorBanner, (state: IBannerReducer) => state.banners);

export const makeSelectorBannerId = (): OutputSelector<
    IRootReducer,
    number | undefined,
    (state: IBannerReducer) => number | undefined
> => createSelector(makeSelectorBanner, (state: IBannerReducer) => state.bannerId);

export const makeSelectorBannerTotalCount = (): OutputSelector<
    IRootReducer,
    number,
    (state: IBannerReducer) => number
> => createSelector(makeSelectorBanner, (state: IBannerReducer) => state.totalCount);
